import { createApp } from 'vue'
import App from './Page.vue'

createApp(App).mount('#app')
